const state = {
    planIndicators: {},
    savingIndicator: false
}

const mutations = {
    setPlanIndicators (state, data) {
        return state.planIndicators = data
    }
}

const actions = {
    fetchPlanIndicators (context, data) {
        axios.get('/api/plan-indicators', {params: data})
        .then( (response) => {
            context.commit("setPlanIndicators", response.data)
        })
        .catch( (e) => {
            console.log("Error: initial.js, fetchPlanIndicators(), "+ e.message)          
        })
    },
    savePlanIndicator (context, data) {
        if (context.state.savingIndicator) {
            return
        }

        context.state.savingIndicator = true

        axios.post('/api/plan-indicator', data)
        .then( (response) => {
            context.commit("setPlanIndicators", response.data)
        })
        .catch( (e) => {
            console.log("Error: plan.js, savePlanIndicator(), "+ e.message)          
        })
        .finally(() => {
            context.state.savingIndicator = false
        })
    }
}

const getters = {
    //
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}